export default __webpack_public_path__ + "static/21_34-7288d8c587f07429a652385ea393fbf9.png";